export default "__VITE_ASSET__0b0148a8__"